// Components
import { Typography, Tooltip } from "@mui/material";
import CustomButton from "../../constants/CustomButton";

export default function LockedCardsDialog() {
  const tooltipContent = (
    <>
      <Typography color="inherit">Active Appointment</Typography>
      <Typography component="div" variant="body2" sx={{ mt: 0.5 }}>
        <em>If you have missed your appointment, the clinic may charge a</em>{" "}
        <strong>no-show fee</strong> <u>$75.00</u>.
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.5 }}>
        Please call the clinic to inform them about the missed appointment.
      </Typography>
    </>
  );

  return (
    <Tooltip title={tooltipContent}>
      <span>
        <CustomButton
          label="Payment Required"
          sx={{ width: "100%" }}
          disabled
        />
      </span>
    </Tooltip>
  );
}
